<template>
  <div id="footer">
    <div class="contacto">
      <div
        class="container fadeInUp wow"
        data-wow-duration="0.5s"
      >
        <div class="row">
          <div class="col">
            <img class="logo-f" alt="CJARA" src="../assets/logo-w.svg" />
          </div>
          <div class="col d-none d-lg-block">
            Nuestros Servicios
            <ul>
              <li><a href="/inspeccion">Inspección Técnica de Obras</a></li>
              <li><a href="/asesoria">Consultoría y Gerenciamiento de Proyectos</a></li>
              <li><a href="/administracion">Administración de Contratos</a></li>
            </ul>
          </div>
          <div class="col text-right">
            <h5>Contáctanos:</h5>
            <a href="mailto:contacto@cjara.cl">
              <span class="pr-2"> <font-awesome-icon icon="envelope"/></span>
              contacto@cjara.cl
            </a> <br><br>
            <h5>Síguenos:</h5>
            <div class="d-block">
              <a href="https://www.facebook.com/CJARA-Consultorias-Inspecci%C3%B3n-T%C3%A9cnica-421231788294025" target="_blank" rel="noopener noreferrer">
            <span class="pr-2 fa-2x"> <font-awesome-icon :icon="['fab', 'facebook-square']"/></span></a>
            <a href="https://www.instagram.com/cjara_consult_inspec_tecnica/" target="_blank" rel="noopener noreferrer">
            <span class="pr-2 fa-2x"> <font-awesome-icon :icon="['fab', 'instagram-square']"/></span></a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="bar-bottom">Todos los derechos reservados 2020</div>
  </div>
</template>
<style lang="scss">
#footer {
  .contacto {
    background: #363636;
    color: white;
    padding: 40px 0 30px 0;
  }
  .logo-f {
    height: 80px;
  }
  .bar-bottom {
    background: black;
    text-align: center;
    color: white;
    padding: 20px 0;
  }
  a {
    color: white;
    text-decoration: none;
    &:hover {
      color: #d32e13;
      text-shadow: 1px 1px 3px black;
    }
  }
  .text-principal {
    color: #d32e13;
    font-weight: 600;
  }
}
</style>
<script>
export default {
  name: "FooterPage",
};
</script>